var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContact({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u56FE\\u5C42_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16 16",
    style: {
      enableBackground: "new 0 0 16 16"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9,3.6c0,0.4-0.2,0.7-0.5,1l-6.3,6.2c-0.6,0.6-1.7,0.6-2.3,0L0.5,4.5C0.2,4.3,0.1,3.9,0,3.6 c0,0.1,0,0.1,0,0.2v8.5c0,0.9,0.7,1.6,1.7,1.6h12.6c0.9,0,1.7-0.7,1.7-1.6V3.8C16,3.7,15.9,3.6,15.9,3.6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.2,9.5L15.8,3c-0.3-0.5-0.8-0.9-1.5-0.9H1.7C1,2.1,0.5,2.5,0.2,3l6.6,6.5C7.5,10.2,8.5,10.2,9.2,9.5L9.2,9.5z "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContact);
export default __webpack_public_path__ + "static/media/contact.1659fb2e706011e98f26ae23c26e469d.svg";
export { ForwardRef as ReactComponent };